import {
  Identifiable,
  Planzone,
  Project,
  Zone,
  project as projectMock,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  zones: (Identifiable<Zone> & { projects: Identifiable<Project>[] })[];
};

function getZonesWithoutRLS(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/planzones/${uuid}?projection=selfAssignmentMenu&embed_links=false`,
        method: HttpMethods.GET,
      })
      .then(({ zones }) => (zones ? zones : []))
      .then((zones) =>
        zones.map((zone) => ({
          ...zone,
          projects: zone.projects.map((project) => ({
            ...projectMock,
            ...project,
          })),
        })),
      )
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getZonesWithoutRLS };
